import { render, staticRenderFns } from "./view2.vue?vue&type=template&id=8f86c90e&scoped=true"
import script from "./view2.vue?vue&type=script&lang=js"
export * from "./view2.vue?vue&type=script&lang=js"
import style0 from "./view2.vue?vue&type=style&index=0&id=8f86c90e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f86c90e",
  null
  
)

export default component.exports